<template>
	<div id="Goods">
		<div class="Goods_box">
			<div class="Goods_nav">
				<div class="left">
					<div class="btn" @click="Switch = '2'" :class="{ 'active': Switch == 2 }">
						<p>
							<img v-if="Switch == 2" src="@/assets/images/bag/get-s.png" alt="">
							<img v-else src="@/assets/images/bag/get-n.png" alt="">
							掉落列表
						</p>
						<i></i>
					</div>
					<div class="btn" @click="Switch = '1'" :class="{ 'active': Switch == 1 }">
						<p>
							<img v-if="Switch == 1" src="@/assets/images/bag/get-s.png" alt="">
							<img v-else src="@/assets/images/bag/get-n.png" alt="">
							最近掉落
						</p>
						<i></i>
					</div>
				</div>
				<div class="right" v-if="Switch == 2">
					<div class="probability-text">
						掉落概率:
					</div>
					<div class="yellow-item">
						<div class="yellow-color">
							<div class="yellow-show">
								<div class="probability">
									{{ yellowProbability + '%' }}
								</div>
							</div>
						</div>
					</div>

					<div class="red-item">
						<div class="red-color">
							<div class="red-show">
								<div class="probability">
									{{ redProbability + '%' }}
								</div>
							</div>
						</div>
					</div>

					<div class="purple-item">
						<div class="purple-color">
							<div class="purple-show">
								<div class="probability">
									{{ purpleProbability + '%' }}
								</div>
							</div>
						</div>
					</div>

					<div class="probability-dec">
						<img src="@/assets/images/public/wenhao.png" alt="">
						<p1 style="cursor: pointer;" @click="Description">概率说明</p1>
					</div>

				</div>
			</div>

			<div class="history_list" v-show="Switch == '1'">
				<div class="history_item" v-for="(item, index) in historylist" :key="index" :class="item.lv | LvGuoLv">
					<!-- <div class="ceng">
						<div class="C_pic">
							<img :src="item.user.avatar" alt="">
							<img v-if="item.user.vipLevel!=0" class = pic_vip :src="GetVipIcon(item.user.vipLevel)" alt="">
						</div>
						<p >{{item.user.name}}</p>
					</div> -->
					<div class="MBX">
						<p><img src="@/assets/images/PublicImg/JinBi.png" alt="">{{ item.bean }}</p>
					</div>
					<div class="history_dura_alias">{{ item.dura_alias }}</div>
					<!-- <div class="history_pic" :style="{ 'background-image': 'url(' + item.lv_bg_image + ')' }"> -->
					<div class="history_pic">
						<img :src="item.cover" alt="">
					</div>
					<p style="margin-bottom: 10px;font-size:14px;">{{ item.name }}</p>
				</div>
			</div>
			<div class="Goods_list" v-show="Switch == '2'">
				<div class="Goods_item" v-for="(item, index) in DetailList" :key="index" :class="item.lv | LvGuoLv">
					<!-- <div class="odds_percent">概率:{{ item.odds_percent }}</div> -->
					<div class="MBX">
						<p><img src="@/assets/images/PublicImg/JinBi.png" alt="">{{ item.bean }}</p>
					</div>
					<div class="dura_alias">{{ item.dura_alias }}</div>
					<div class="Goods_pic">
						<img :src="item.cover" alt="">
					</div>
                    <p style="margin-bottom: 10px;font-size:14px;">{{ item.name }}</p>
				</div>
			</div>
		</div>


		<van-overlay :show="showDescription" @click="showDescription = false">
			<div style="display: flex;align-items: center;justify-content: center;height: 100%;">
				<img style="width: 567px; height: 612px;" src="@/assets/images/public/showDescription.png" alt="">
			</div>
		</van-overlay>

	</div>
</template>

<script>
import {
	UnpackingRecord
} from '@/network/api.js'
export default {
	name: 'Goods',
	props: {
		DetailList: {
			type: Array
		},
		id: {
			type: String
		},

		yellowProbability: {
			type: String
		},
		redProbability: {
			type: String
		},
		purpleProbability: {
			type: String
		}
	},
	data() {
		return {
			Switch: '2',
			historylist: [],
			timer: null,
			update: true,
			showDescription: false	///显示概率说明
		}
	},
	activated() {
		this.GetUnpackingRecord()
		this.SetUnpackingRecord()

	},
	methods: {
		Description() {
			this.showDescription = true;
		},
		GetVipIcon(level) {
			if (level == 1) {
				return require('@/assets/images/vip/VIP-1.png');
			} else if (level == 2) {
				return require('@/assets/images/vip/VIP-2.png');
			} else if (level == 3) {
				return require('@/assets/images/vip/VIP-3.png');
			} else if (level == 4) {
				return require('@/assets/images/vip/VIP-4.png');
			} else if (level == 5) {
				return require('@/assets/images/vip/VIP-5.png');
			}
			else if (level == 6) {
				return require('@/assets/images/vip/VIP-6.png');
			}
			else if (level == 7) {
				return require('@/assets/images/vip/VIP-7.png');
			}
			else if (level == 8) {
				return require('@/assets/images/vip/VIP-8.png');
			}
			else if (level == 9) {
				return require('@/assets/images/vip/VIP-9.png');
			}
			else if (level == 10) {
				return require('@/assets/images/vip/VIP-10.png');
			}
			else if (level == 11) {
				return require('@/assets/images/vip/VIP-11.png');
			}
			else if (level == 12) {
				return require('@/assets/images/vip/VIP-12.png');
			}
			return require('@/assets/images/vip/VIP-1.png');
		},
		GetUnpackingRecord() {
			UnpackingRecord(this.id).then((res) => {
				this.historylist = res.data.data.historylist;
				//console.log(this.historylist);

			})
		},
		SetUnpackingRecord() {
			setInterval(() => {
				if (this.update)
					this.GetUnpackingRecord()
			}, 5000)
		},
	},


	watch: {
		id(v) {
			this.GetUnpackingRecord()
		},
		DetailList(v) {

		}
	},
	created() {
		this.$root.eventHub.$on('updateHistory', () => {
			this.update = true;
			this.GetUnpackingRecord();
		}),
			this.$root.eventHub.$on('StopUpdateHistory', () => {
				this.update = false;
			})
	},

	filters: {
		LvGuoLv(val) {
			if (val == '1') {
				return 'lv1'
			} else if (val == '2') {
				return 'lv2'
			} else if (val == '3') {
				return 'lv3'
			} else if (val == '4') {
				return 'lv4'
			} else if (val == '5') {
				return 'lv5'
			}
		},
	},
}
</script>

<style lang="scss">
#Goods {
	box-sizing: border-box;
	.probability-text {
		color: rgb(209, 209, 209);
		font-size: 14px;

	}

	.probability {
		color: rgb(209, 209, 209);
		line-height: .25rem;
		font-size: 12px;
        font-family: 'Oxanium';
	}

	.yellow-item {
		margin-left: 10px;
		width: 60px;

		.yellow-color {
			width: 7px;
			background-color: #ffc718;
		}

		.yellow-show {
			text-align: center;
			height: 22px;
			width: 60px;
			background: linear-gradient(to right, rgba(255, 199, 24, .15), rgba(35, 33, 68, 0));
		}
	}

	.red-item {
		margin-left: 10px;
		width: 60px;

		.red-color {
			width: 7px;
			background-color: #d9120e;
		}

		.red-show {
			text-align: center;
			height: 22px;
			width: 60px;
			background: linear-gradient(to right, rgba(217, 18, 14, .15), rgba(35, 33, 68, 0));
		}
	}

	.purple-item {
		margin-left: 10px;
		width: 60px;

		.purple-color {
			width: 7px;
			background-color: #3d5979;
		}

		.purple-show {
			text-align: center;
			height: 22px;
			width: 60px;
			background: linear-gradient(to right, rgba(61, 89, 121, .15), rgba(35, 33, 68, 0));
		}
	}


	.Goods_box {
		width: 100%;
		.Goods_nav {
			width: 100%;
			display: flex;
			color: #fff;
			justify-content: space-between;
		
			.left {
				display: flex;
				align-items: center;
				.btn {
					width: 220px;
					height: 80px;
					text-align: center;
					position: relative;
					display: flex;
					justify-content: center;
					cursor: pointer;
                    
					p {
						color: #FFFFFF;
						font-size: 15px;
						display: flex;
						align-items: center;

						& img {
							width: 20px;
							margin-right: 1px;
						}
					}

					i {
						display: block;
						width: 100%;
						height:2px;
						position: absolute;
						background: #91743e;
						left: 50%;
						bottom: 0;
						transform: translateX(-50%);
						opacity: 0;
					}

					&:hover {
						background: rgba($color: #ffa07a, $alpha: .03);
					}

					&.active {
						background: rgba($color: #fff, $alpha: .03);

						i {
							opacity: 1;
						}
					}
				}
			}
			.right {
	    		display: flex;
				align-items:flex-end;
			}
			.probability-dec {
				color: rgb(209, 209, 209);
				font-size: 14px;
				display: flex;
				text-align: right;
				margin-right: 30px;

				img {
					width: 16px;
					height: 16px;
				}
			}



		}

		.history_list {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			.history_item {
                position: relative;
                width: 225px;
                margin: 4px;
				text-align: center;
				color: #fff;
				background: url(../../assets/images/Roll/LV1.png) no-repeat center;
				background-size: 100% 100%;
				overflow: hidden;
				&.lv1 {
					background: url(../../assets/images/Roll/LV1.png) no-repeat center;
					background-size: 100% 100%;
				}

				&.lv2 {
					background: url(../../assets/images/Roll/LV2.png) no-repeat center;
					background-size: 100% 100%;
				}

				&.lv3 {
					background: url(../../assets/images/Roll/LV2.png) no-repeat center;
					background-size: 100% 100%;
				}

				&.lv4 {
					background: url(../../assets/images/Roll/LV3.png) no-repeat center;
					background-size: 100% 100%;
				}

				&.lv5 {
					background: url(../../assets/images/Roll/LV3.png) no-repeat center;
					background-size: 100% 100%;
				}

				.MBX {
                    width: 100%;
                    height: 50px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 10px 15px;
                    box-sizing: border-box;

					p {
						font-size: 15px;
						color: #FFD077;
						display: flex;
						align-items: center;
                        font-family: 'Oxanium';
						img {
                            width: 20px;
                            height: 20px;
                            vertical-align: middle;
                            margin: 0 1px 2px 0;
						}
					}
				}

				.ceng {
					position: absolute;
					left: 0;
					top: -100%;
					width: 100%;
					height: 100%;
					background: rgba($color: #000000, $alpha: .6);
					text-align: center;
					transition: .3s;

					.C_pic {
						width: 50px;
						height: 50px;
						border-radius: 50%;
						overflow: hidden;
						margin: 40px auto 10px;

						img {
							width: 100%;
							height: 100%;
						}

						p {
							font-size: 14px;
							color: #fff;
                            
						}

						.pic_vip {
							width: 50px;
							height: 50px;
							position: absolute;
							left: .9rem;
							top: 56px;
							display: flex;
							justify-content: center;
							align-items: center;
							z-index: 10;
							border: none;
						}


					}
				}

				&:hover {
					.ceng {
						top: 0
					}
				}

				.history_pic {
					width: 80%;
					height: 150px;
					margin: 0 auto;
					display: flex;
					justify-content: center;
					align-items: center;
                    img {
                        max-width: 100%;
                        max-height: 100%;
				    }
				}

				p {
					width: 100%;
					padding: 0 3px;
					box-sizing: border-box;
					font-size: 14px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}

			.history_dura_alias {
				position: absolute;
				right: 0;
				top: 0;
				font-size: 14px;
				text-align: left;
                padding: 15px 15px;
				box-sizing: border-box;
				color: rgb(179, 179, 179);
			}

		}

		.Goods_list {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			border-radius:4px;
			.Goods_item {
                width: 225px;
                margin: 4px;
				text-align: center;
				color: #fff;
				background: url(../../assets/images/Roll/LV1.png) no-repeat center;
				background-size: 100% 100%;
				position: relative;
				overflow: hidden;

				&.lv1 {
					background: url(../../assets/images/Roll/LV1.png) no-repeat center;
					background-size: 100% 100%;
				}

				&.lv2 {
					background: url(../../assets/images/Roll/LV2.png) no-repeat center;
					background-size: 100% 100%;
				}

				&.lv3 {
					background: url(../../assets/images/Roll/LV2.png) no-repeat center;
					background-size: 100% 100%;
				}

				&.lv4 {
					background: url(../../assets/images/Roll/LV3.png) no-repeat center;
					background-size: 100% 100%;
				}

				&.lv5 {
					background: url(../../assets/images/Roll/LV3.png) no-repeat center;
					background-size: 100% 100%;
				}

				.MBX {
                    width: 100%;
                    height: 50px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 10px 15px;
                    box-sizing: border-box;

					p {
						font-size: 15px;
						color: #FFD077;
						display: flex;
						align-items: center;
                        font-family: 'Oxanium';
						img {
                            width: 20px;
                            height: 20px;
                            vertical-align: middle;
                            margin: 0 1px 2px 0;
						}
					}
				}

				.dura_alias {
                    position: absolute;
                    right: 0;
                    top: 0;
                    font-size: 14px;
                    text-align: left;
                    padding: 15px 15px;
                    box-sizing: border-box;
                    color: rgb(179, 179, 179);
				}


				.Goods_pic {
					width: 80%;
					height: 150px;
					margin: 0 auto;
					display: flex;
					justify-content: center;
					align-items: center;
					// background-image: url(http://csgo.api.gameskins.cn/uploads/images/baeef9d5696b72118858f87ff955bee7.png);
					// background-position: center;
					// background-size: 80%;
					// background-repeat: no-repeat;

                    img {
                        max-width: 100%;
                        max-height: 100%;
				    }
				}

				p {
					width: 100%;
					padding: 0 3px;
					box-sizing: border-box;
					font-size: 14px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}
		}
	}
}
</style>
